import React, { Component } from "react";
import { HashLoader } from "react-spinners";

const override = {
  display: "block",
  borderColor: "red",
};

class HashingLoader extends Component {
  render() {
    const { size, color } = this.props;
    return (
      <div className="sweet-loading">
        <HashLoader
          style={override}
          size={size ? size : 5}
          color={color ? color : "#fff"}
          loading={true}
        />
      </div>
    );
  }
}

export default HashingLoader;
